const ChineseMedicine = () => import('@pages/introduce/ChineseMedicine')
const Cosmetology = () => import('@pages/introduce/Cosmetology')
const Oral = () => import('@pages/introduce/Oral')
const CmMedia = () => import('@pages/introduce/CmMedia')
const CmMediaDetail = () => import('@pages/introduce/CmMediaDetail')

export const introduce = [
  {
    path: '/introduce/chinese_medicine',
    name: 'ChineseMedicine',
    component: ChineseMedicine,
    meta: {}
  },
  {
    path: '/introduce/cosmetology',
    name: 'Cosmetology',
    component: Cosmetology,
    meta: {}
  },
  {
    path: '/introduce/oral',
    name: 'Oral',
    component: Oral,
    meta: {}
  },
  {
    path: '/introduce/chinese_medicine/media',
    name: 'CmMedia',
    component: CmMedia,
    meta: {}
  },
  {
    path: '/introduce/chinese_medicine/media/:id',
    name: 'CmMediaDetail',
    component: CmMediaDetail,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/introduce.route.js